import React from "react";
import Meta from "../../components/Meta";
import Image from "next/image";
import { getTermsAndConditions } from "../../lib/posts";

const Terms = (
  { data }
) => {
  return (
    <div>
      <Meta title="Terms & Conditions || NetZylo" />
      <div className="pt-[5.5rem] lg:pt-24">
        {/* <!-- TOS --> */}
        <section className="dark:bg-jacarta-900 relative py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <Image
              width={1519}
              height={773}
              priority
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          <div className="">
            <h1 className="font-display text-jacarta-900 text-center text-4xl font-medium dark:text-white">
              Terms Of Service
            </h1>
            <div className="max-w-7xl mx-auto px-4 py-8">
              <div className="prose max-w-full text-white terms" dangerouslySetInnerHTML={{ __html: data }} />
            </div>
          </div>
        </section>
        {/* <!-- end TOS --> */}
      </div>
    </div>
  );
};

export default Terms;
export async function getServerSideProps() {
  const data = await getTermsAndConditions()

  if (!data) {
    return {
      props: {},
      notFound: true,
    };
  }

  return {
    props: { data },
    // revalidate: 300,
  };
}